import AffirmationTranslationsResponse from '../../../../../Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationTranslationsResponse';

export default class AffirmationGetDetailResponse  {
	Id: number = 0;
	IsPaid: boolean = false;
	Created: Date = null;
	UseBackgroundMusic: boolean = false;
	IconUrl?: string = '';
	CoverUrl?: string = '';
	BackUrl?: string = '';
	AnimationId?: string = '';
	AnimationUrl?: string = '';
	Translations: Array<AffirmationTranslationsResponse> = null;
	constructor(obj?: Partial<AffirmationGetDetailResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
